import { READ_LIST, READ_LIST_SUCCEEDED, READ_LIST_FAILED } from "../types"

export const readList = config => {
  return { type: READ_LIST, config }
}

export const readListSuccess = (action, response) => {
  return { type: READ_LIST_SUCCEEDED, action, response, config: action.config }
}

export const readListError = (action, error) => {
  return { type: READ_LIST_FAILED, action, error }
}
